module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-package-734d17ad8bc80f826433f2ff696d3ddd.png";